class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();
    this.loadRecommendations();
  }

  loadRecommendations() {
    const productId = this.dataset.productId;
    if (!productId) return;

    const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('cart-drawer-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
